<template>
  <DestinationWeather
    class="pb-12"
    :content="getFilteredSection('weather')"
    title="charterDestinationWeatherTitle"
    is-tab-view
  />
</template>

<script setup>
const props = defineProps({
  destination: {
    type: Object,
    default: () => ({}),
  },
  filledSections: {
    type: Array,
    default: () => [],
  },
})

const getFilteredSection = (filterString) => {
  const section = props.filledSections.find(section => section.type === filterString)
  return section ? section : null
}
</script>

<style lang="scss" scoped>

</style>